// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getGatewayVoucherUrl, redirectIfCheckForConfirmationIsEnabled } from '@tectonics/prs/incoming-payment';
import { LinkButton } from './render-helpers';

type BarCodeButtonProps = {|
  buttonMessage: string,
  inverseStyle?: boolean,
  format?: string,
|};

export function ShowBarcodePdfButton({ buttonMessage, inverseStyle=false, format = null }: BarCodeButtonProps): Node {
  const incomingPayment = usePendingIncomingPayment();
  const voucherUrl = getGatewayVoucherUrl(incomingPayment) + (format === 'pdf' ? '&format=pdf' : '');
  return (
    <LinkButton inverseStyle={inverseStyle} aria-label={buttonMessage} type="primary" flat as="a" target="blank" href={voucherUrl} contentDesktop={buttonMessage} contentMobile={format === 'pdf' ? buttonMessage : null} data-test-id="pagos-button" onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) } />
  );
}
